import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { changeVisualizationContext, getVisualizationContext } from './../../MainMenu/OnlyCash/actions'
import PointsInformation from './PointsInformation'
import { Icon } from 'loyal-react'

class UserBasicInformation extends Component {
  constructor (props) {
    super(props)

    this.state = {
      hideValue: false,
      isFlagChoiceOpened: false,
      cash: false,
      smallHeader: false
    }
  }

  componentDidMount () {
    if (this.props.catalogJustCash) {
      this.props.getVisualizationContext()
      this.props.onlyCash && this.setState({ cash: this.props.onlyCash })
    } else {
      this.setState({ cash: false })
    }
    this.setState({ changeContext: false })

    window.onscroll = function () { scrollHeader() }

    const scrollHeader = () => {
      if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
        this.setState({ smallHeader: true })
      } else {
        this.setState({ smallHeader: false })
      }
    }
  }

  componentDidUpdate () {
    if (this.state.cash !== this.props.onlyCash) {
      this.setCash(this.props.onlyCash)
    }
  }

  setCash = value => this.setState({ cash: this.props.onlyCash })

  formatName = name => {
    return name.split(' ')[0]
  }

  formatPoints = (value) => {
    return parseFloat(value.toFixed(0)).toLocaleString('pt-br', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    })
  }

  hideValue = () => {
    window.localStorage.setItem('hideValue', !this.state.hideValue)
    this.setState({
      hideValue: !this.state.hideValue
    })
  }

  returnPoints = () => {
    return this.formatPoints(this.props.pointsValue) + ' ' + this.props.pointsName
  }

  maskedValue = () => {
    let hiddenPoints = this.returnPoints()

    return hiddenPoints.replace(/./g, '*')
  }

  openFlagArea = () => {
    this.setState({
      isFlagChoiceOpened: !this.state.isFlagChoiceOpened
    })
  }

  pointsCash = type => {
    if (type === 'cash') {
      this.setState({ cash: true })
      this.props.SetOnlyCash(true)
    } else {
      this.props.SetOnlyCash(false)
    }

    setTimeout(() => {
      window.location.href = '/'
    }, 1500)
  }

  render () {
    return (
      <Fragment>
        <div
          className={`container-points-toogle col-12 pos-relative py-1 t-5 mt-1 container-fluid border-top border-top-color-brand-3 container-header d-print-none user-basic-information ${!this.state.smallHeader ? 'py-2' : ''}`}
        >
          <div className='row align-items-center h-100'>
            <div className={`col-12 px-2 txt-left pointer color-brand-5 ${!this.state.smallHeader ? 'props-small-header' : ''} small-header`}>
              <span className='txt-font-body txt-body-sm'>
                {`Olá, ${this.formatName(this.props.userInfo.name)}! Você tem `}
                {this.props.isLoading ? (
                  'Carregando pontuação'
                ) : (
                  <Fragment>
                    <br />
                    <PointsInformation
                      hideValue={this.state.hideValue}
                      maskedValue={this.maskedValue()}
                      formatPoints={this.returnPoints()}
                    />
                    <a
                      onClick={() => this.hideValue()}
                      href='javascript:void(0)'
                      role='button'
                      aria-label={window.localStorage.getItem('hideValue') === 'true' || this.state.hideValue ? 'Exibir pontuação' : 'Esconder pontuação'}
                      className='d-inline-block ml-1'
                    >
                      <Icon
                        iconName={window.localStorage.getItem('hideValue') === 'true' || this.state.hideValue ? 'icon_no_view' : 'icon_view'}
                        className='color-brand-5 txt-body-sm position-relative pos-relative l-0 t-0'
                      />
                      <span className='hide-absolute'>{this.state.isFlagChoiceOpened ? 'Fechar seleção do formato' : 'Selecionar formato de resgate' }</span>
                    </a>
                  </Fragment>
                )}
              </span>
            </div>

            {this.props.catalogJustCash &&
            <Fragment>
              <div
                className={`col-3 px-2 txt-left pointer color-brand-5 pointer ${!this.state.smallHeader ? 'not-props-small-header' : ''} small-header`}
              >
                <p className='open-flag'>
                  <Icon
                    iconName={this.state.cash ? 'icon_cash' : 'icon_points'}
                    className='color-brand-5 txt-body-sm'
                  />
                  <a
                    onClick={this.openFlagArea}
                    href='javascript:void(0)'
                    role='button'
                    aria-expanded={this.state.isFlagChoiceOpened}
                    aria-label={this.state.isFlagChoiceOpened ? 'Fechar seleção do formato' : 'Selecionar formato de resgate'}
                  >
                    <Icon
                      iconName={this.state.isFlagChoiceOpened ? 'icon_up' : 'icon_down'}
                      className='color-brand-5 txt-body-sm'
                    />
                    <span className='hide-absolute'>{this.state.isFlagChoiceOpened ? 'Fechar seleção do formato' : 'Selecionar formato de resgate' }</span>
                  </a>
                </p>
              </div>
              <div className={`col-12 ${this.state.isFlagChoiceOpened ? '' : 'd-none'}`}>
                <ul className={`row`}>
                  <li className={`col-6 pl-2 pt-1 pb-2 show-tablet`}>
                    <button
                      className={`btn-sm btn btn-icon border border-color-${!this.state.cash ? 'featured' : 'brand-3'} border-radius pl-5 pr-0 py-1 txt-left`}
                      onClick={() => this.pointsCash('points')}
                      role='button'
                      aria-label={`Troque seus pontos${!this.state.cash ? ' (Selecionado)' : ''}`}
                    >
                      <Icon
                        iconName={'icon_points'}
                        className={`color-${!this.state.cash ? 'featured' : 'brand-5'}`}
                      />
                      Troque<br />seus pontos
                    </button>
                  </li>
                  <li className={`col-6 pl-2 pt-1 pb-2 show-tablet`}>
                    <button
                      className={`btn-sm btn btn-icon border border-color-${this.state.cash ? 'featured' : 'brand-3'} border-radius pl-5 pr-0 py-1 txt-left`}
                      onClick={() => this.pointsCash('cash')}
                      role='button'
                      aria-label={`Compre com cartão${this.state.cash ? ' (Selecionado)' : ''}`}
                    >
                      <Icon
                        iconName={'icon_cash'}
                        className={`color-${this.state.cash ? 'featured' : 'brand-5'}`}
                      />
                      Compre<br />com cartão
                    </button>
                  </li>
                </ul>
              </div>
              <div />
              <div className={`${this.state.isFlagChoiceOpened ? 'col-6 pr-2 pt-1 pb-2 show-tablet' : 'd-none'} `} />
            </Fragment>
            }
          </div>
        </div>
      </Fragment>
    )
  }
}

UserBasicInformation.propTypes = {
  isLoading: PropTypes.bool,
  userInfo: PropTypes.object,
  pointsValue: PropTypes.number,
  pointsName: PropTypes.string,
  SetOnlyCash: PropTypes.func,
  catalogJustCash: PropTypes.bool,
  onlyCash: PropTypes.bool,
  getVisualizationContext: PropTypes.func
}

const mapStateToProps = ({ oidc, balance, catalog, onlyCash }) => ({
  userInfo: oidc.user.profile,
  isLoading: balance.isLoading,
  pointsValue: balance.pointsValue,
  pointsName: catalog.currencyConfiguration.pointsName,
  catalogJustCash: catalog.onlyCash,
  onlyCash
})

const mapDispatchToProps = dispatch => ({
  SetOnlyCash: cash => dispatch(changeVisualizationContext(cash)),
  getVisualizationContext: () => dispatch(getVisualizationContext())
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UserBasicInformation)



// WEBPACK FOOTER //
// ./src/App/Header/UserBasicInformation/UserBasicInformation.js